import ResourceModal from 'app/components/ResourceModal';
import CustomersUploadForm from './CustomersUploadForm';

const CustomersUploadModal = props => {
  const {
    isOpen,
    onClose,
    onFormSubmit,
    job,
    center
  } = props;

  let action = 'create';
  let title = 'Upload Customer Moments';
  let message = 'These moments will be assigned to the selected customers';
  let unmountOnClose = true;

  const onSubmit = params => onFormSubmit(action, params);

  return (
    <ResourceModal {...{ isOpen, onClose, title, message, center, unmountOnClose }}>
      <CustomersUploadForm {...{ action, onClose, onSubmit, job }} />
    </ResourceModal>
  );
}

export default CustomersUploadModal;
